module.exports = __webpack_public_path__ + "static/img/v8.328fa5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v8.svg
// module id = kqCc
// module chunks = 0